module.exports = __webpack_public_path__ + "img/order3.e20a440d.svg";